import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const StatsLoading = () => {
  return (
    <>
      <div className="col-md-4" id="buyers">
        <div
          className="bg-white rounded-4 shadow-sm p-3 h-100 d-flex flex-column justify-content-between"
          style={{ minHeight: "150px", border: "1px solid rgba(226, 232, 240, 0.8)" }}
        >
          <div className="d-flex align-items-center justify-content-between mb-2">
            <Skeleton circle width={38} height={38} />
            <Skeleton width={60} height={20} borderRadius={10} />
          </div>
          <div className="row g-0 pt-2 border-top">
            <div className="col-6 pe-2 border-end">
              <Skeleton width={60} height={12} />
              <Skeleton width={40} height={24} />
            </div>
            <div className="col-6 ps-3">
              <Skeleton width={60} height={12} />
              <Skeleton width={40} height={24} />
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-4" id="sales">
        <div
          className="bg-white rounded-4 shadow-sm p-3 h-100 d-flex flex-column justify-content-between"
          style={{ minHeight: "150px", border: "1px solid rgba(226, 232, 240, 0.8)" }}
        >
          <div className="d-flex align-items-center justify-content-between mb-2">
            <Skeleton circle width={38} height={38} />
            <Skeleton width={40} height={20} borderRadius={10} />
          </div>
          <div className="pt-2 border-top">
            <Skeleton width={100} height={24} />
            <Skeleton width={80} height={12} />
          </div>
        </div>
      </div>
      <div className="col-md-4" id="purchases">
        <div
          className="bg-white rounded-4 shadow-sm p-3 h-100 d-flex flex-column justify-content-between"
          style={{ minHeight: "150px", border: "1px solid rgba(226, 232, 240, 0.8)" }}
        >
          <div className="d-flex align-items-center justify-content-between mb-2">
            <Skeleton circle width={38} height={38} />
            <Skeleton width={40} height={20} borderRadius={10} />
          </div>
          <div className="pt-2 border-top">
            <Skeleton width={100} height={24} />
            <Skeleton width={80} height={12} />
          </div>
        </div>
      </div>
    </>
  );
};

export default StatsLoading;
